const config = {
    comingSoon: false,
    maintenance: false,
    isLive: true
}

export default config;